import { gameLeave } from '@/api/game'
import { showNotice, showConfirm } from '@/utils/tool'
import store from 'vuex-store/index'
import router from '@/router'
import i18n from '@/i18n'

// type = game or provider
export function gameStart(type, gameOrProvider) {
  if (!store.getters.token) {
    // 未登入
    store.commit('SET_LOGIN_OPEN', true)
  } else if (type === 'game' && gameOrProvider.status === 2) {
    // 遊戲維護中
    showNotice(i18n.t('Bao.game_maintenance'))
  } else {
    // 檢查用戶是否開啟自動上分
    if (store.getters.user.auto_to_game !== 1) {
      const gameProviderId = type === 'provider' ? gameOrProvider.id : gameOrProvider.game_provider_id
      // 彈出確認視窗
      showConfirm(i18n.t('Bao.please_select_game_method'), i18n.t('Bao.to_game_directly'), i18n.t('Bao.to_game_transfer'), function() {
        store.dispatch('launchGame', { type, gameOrProvider })
      }, function() {
        showGameWalletModal(gameProviderId, 'in', () => {
          store.dispatch('launchGame', { type, gameOrProvider })
        })
      })
    } else {
      // 實際進入遊戲
      store.dispatch('launchGame', { type, gameOrProvider })
    }
  }
}

export function gameEnd(game_id) {
  if (!store.getters.token) {
    return
  }
  // loading開始
  store.commit('SET_LOADING', true)

  // const game_id = store.getters.inGameId

  console.log('leave game', game_id)

  store.commit('SET_IN_GAME_ID', null)
  if (game_id) {
    showNotice('closeModal')

    gameLeave(game_id).then(response => {
      // 寫入遊戲餘額
      const current = store.getters.gameBalance
      const gameBalance = response.data.data
      current[gameBalance.game_provider_id] = gameBalance
      store.commit('SET_GAME_BALANCE_INFO', current)

      // loading結束
      store.commit('SET_LOADING', false)
      // router.push({ path: '/index/' + store.getters.leaveGamePath }).catch(() => {
      // })
    })
  } else {
    store.commit('SET_LOADING', false)
  }
}

// 供應商判斷自動進遊戲 或是進列表
export function providerLink(provider) {
  if (provider.singleGame) {
    gameStart('provider', provider)
  } else {
    // 隱藏menu
    // const wraps = document.getElementsByClassName('menu_wrap')
    // for (const element of wraps) {
    //   element.classList.add('d-none')
    // }
    // window.setTimeout(() => {
    //   for (const element of wraps) {
    //     element.classList.remove('d-none')
    //   }
    // }, 800)
    // store.commit('SET_LOAD_COMPLETED', false)
    // setTimeout(() => {
    //   store.commit('SET_LOAD_COMPLETED', true)
    // }, 100)
    router.push({ path: '/game/provider/' + provider.id }).catch(() => {})
  }
}

export function showGameWalletModal(gameProviderId, fixType, callback) {
  const data = {
    gameProviderId: gameProviderId,
    fixType: fixType === undefined ? false : fixType,
    callback: callback
  }

  store.commit('SET_GAME_WALLET_MODAL', data)
}
export function hideGameWalletModal() {
  store.commit('SET_GAME_WALLET_MODAL', false)
}
